<evc-svg-icon class="evc-svg-icon" [icon]="checked? checkedIcon: unCheckedIcon" [size]="'md'"></evc-svg-icon>
<div>
  {{label}}
</div>
